const backendUrl =
  process.env.NODE_ENV === "production"
    ? "https://gourmet-ai-backend-bok47lw6aq-uc.a.run.app"
    : "http://localhost:8000";

export default backendUrl;
